import { gql, useMutation } from '@apollo/client'

const UNSKIP_ORDER_IN_PAUSE = gql`
  mutation unskipOrderInPause($deliveryDate: String!) {
    unskipOrderInPause(delivery_date: $deliveryDate)
  }
`

export function useUnskipOrderInPause({ onCompleted }) {
  const [unskipOrderInPause, rest] = useMutation(UNSKIP_ORDER_IN_PAUSE, {
    refetchQueries: ['lastSkips', 'deliveryDayInfo'],
    notifyOnNetworkStatusChange: true,
    onCompleted
  })

  return {
    unskipOrderInPause: (variables: { deliveryDate: string | undefined }) =>
      unskipOrderInPause({ variables }),
    ...rest
  }
}
